module.exports = __webpack_public_path__ + "static/media/bw.cf9703f2.png";